import React from 'react';
import { HeartIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { findPerson } from '../data/people';
import { useLocale } from '../contexts/LocaleContext';
import { useSocial } from '../contexts/SocialContext';
import type { Comment, CommentReply } from '../types';
function Row({
  entry,
  nested = false
}: {
  entry: CommentReply;
  nested?: boolean;
}) {
  const {
    t,
    tl
  } = useLocale();
  const social = useSocial();
  const author = findPerson(entry.authorId);
  const liked = social.isCommentLiked(entry.id);
  return <div className={`flex gap-2 ${nested ? 'pl-5' : ''}`} data-id="element-615" data-mp="4zj08d291i77">
      <Avatar src={author.avatar} name={author.name} size={nested ? 28 : 34} data-id="element-616" data-mp="joyp1ni7zdk9" />
      <div className="min-w-0 flex-1" data-id="element-617" data-mp="epug8xz7jhug">
        <p className="text-[12.5px] font-medium text-deep" data-id="element-618" data-mp="eqx755wj5kad">
          {author.name}
          <span className="ml-1 font-normal text-muted" data-id="element-619" data-mp="soloi3re29ao">
            · {t('post.hoursAgo', {
            n: entry.hoursAgo
          })}
          </span>
        </p>
        <p className="mt-[2px] text-[13px] leading-relaxed text-deep" data-id="element-620" data-mp="no7ier9cl9fa">
          {tl(entry.text)}
        </p>
        <button type="button" onClick={() => social.likeComment(entry.id)} aria-pressed={liked} className={`mt-1 flex min-h-[32px] items-center gap-1 text-[11px] font-medium transition-colors duration-150 ease-brand ${liked ? 'text-gold-deep' : 'text-muted hover:text-deep'}`} data-id="element-621" data-mp="2gjp6g8o10voo">
          <HeartIcon size={13} fill={liked ? 'currentColor' : 'none'} data-id="element-622" data-mp="2zf5lyia4i31m" />
          <span className="bee-num" data-id="element-623" data-mp="34f07s7f1k2ft">{entry.likes + (liked ? 1 : 0)}</span>
        </button>
      </div>
    </div>;
}
export function CommentItem({
  comment
}: {
  comment: Comment;
}) {
  return <li className="border-b border-sand-line py-2 last:border-b-0" data-id="element-624" data-mp="3e4tmviee6zot">
      <Row entry={comment} data-id="element-625" data-mp="3e75zrh5amjv0" />
      {comment.replies.length > 0 && <ul className="mt-2 space-y-2" data-id="element-626" data-mp="3j5h97qroescp">
          {comment.replies.map(reply => <li key={reply.id} data-id="element-627" data-mp="3n6t4ocx8e7st">
              <Row entry={reply} nested data-id="element-628" data-mp="3n616cuc91vyu" />
            </li>)}
        </ul>}
    </li>;
}